import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import Progress from "../../../../../../../ui/Progress";
import EditRolesForm from "../EditRolesForm";
import { loadList } from "../../../../../../../Dict/Roles/View/fetch";
import { updateRoles } from "../../../../store/send";

const styles = theme => ({
  dialog: {
    width: "476px"
  }
});

const EditRolesModal = ({
  open,
  handleClose,
  loadList,
  rolesList = [],
  personRoles,
  updateRoles,
  updatedRoles,
  isUpdatingRoles,
  classes
}) => {
  const [formData, updateFormData] = React.useState(null);
  const [isEdited, setIsEdited] = React.useState(false);

  const onConfirm = () => {
    updateRoles(formData);
  };

  const onClose = () => {
    updateFormData(null);
    setIsEdited(false);
    handleClose();
  };

  React.useEffect(() => {
    loadList();
  }, []);

  React.useEffect(() => {
    if (updatedRoles && updatedRoles.success) {
      onClose();
    }
  }, [updatedRoles]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Редактировать роли пользователя</DialogTitle>
        <DialogContent>
          {rolesList ?
          <EditRolesForm
            personRoles={personRoles}
            rolesList={rolesList}
            onFormChange={(data) => {
              updateFormData(data);
              setIsEdited(true);}
            }
          />
        : <Progress/>}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Отмена</Button>
          <Button
            loading={isUpdatingRoles}
            disabled={isUpdatingRoles || !isEdited}
            onClick={() => onConfirm()}
            color="green"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  rolesList: state.dictRolesView.list,
  isUpdatingRoles: state.persons.isUpdatingRoles,
  updatedRoles: state.persons.updatedRoles
});

const mapDispatchToProps = dispatch => ({
  loadList: () => dispatch(loadList()),
  updateRoles: (data) => dispatch(updateRoles(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(EditRolesModal)));
